<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="toolbar-button" @click="jobSeekerDrawer = true">
        <img :src="require('@/assets/img/icons/home.svg')" />
      </ion-button>
    </ion-buttons>
    <ion-title>
      <img v-if="isAustralia" :src="require('@/assets/img/toolbar-logo.png')" :alt="$filters.appName()">
      <img v-if="isUS" :src="require('@/assets/img/us/toolbar-logo-us.png')" :alt="$filters.appName()">
    </ion-title>
    <ion-buttons slot="end">
      <ion-button class="notifications_button toolbar-button" @click="links.changeBasicProfileJobSeeker">
        <EditIcon />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <!-- Job Seeker Profile Static Page -->
    <div class="container">
      <div class="profile-preview-wrapper">
        <div class="preview-section">
          <div class="profile-picture">
            <el-avatar :size="'large'" :src="userData?.image" v-if="userData?.image" />
            <el-avatar :size="'large'" icon="el-icon-user-solid" v-else></el-avatar>
            <el-button type="transparent" @click="links.changePhoto" data-testid="avatar-btn">
              <span class="locumate_icons locumate_icon-camera"></span>
            </el-button>
          </div>
          <div class="profile-info">
            <div class="profile-name">
              {{ userData.name }}
            </div>
            <div class="profile-type">
              <!-- {{ $filters.userRoleConversion(userData) }} -->
                {{ userData.platformRole }}
            </div>
          </div>
        </div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              About Me
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <p class="preview-section__content">
            {{ displayedText }}
            <el-button class="text-only" @click="toggleView" v-if="isDisplayButtonVisible"> {{ state.isTruncated ? 'View More' : 'View Less' }}</el-button>
          </p>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Basic Details
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item__icon">
              <SmsTrackingIcon width="18" height="18" />
            </div>
            <div class="detail-item__value">{{ userData.email }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-item__icon">
              <MobileIcon />
            </div>
            <div class="detail-item__value">{{ userData.mobileNumber }}</div>
          </div>
          <div class="detail-item" v-if="userData.hrFlowData?.educations.length && userData.hrFlowData.educations[0]?.title">
            <div class="detail-item__icon">
              <TeacherIcon />
            </div>
             <div class="detail-item__value">{{ userData.hrFlowData.educations[0].title }}</div>
          </div>
          <div class="detail-item" v-if="userData.seekerRole?.length">
            <div class="detail-item__icon">
              <ProfileTickIcon />
            </div>
            <div class="detail-item__value">{{ userData.seekerRole.map(skill => 
                  skill === "Other" ? `${skill}: ${userData.settings.categoryLevelOther}` : skill
                ).join(", ") }}</div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Experience
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openExperienceDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <div class="enhance-item border-box" v-for="(exp, index) in experiences"
            :key="index">
            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2459_4910)">
                  <path
                    d="M16.2354 0H7.76481V8.47059H16.2354V0ZM14.1177 4.94118H12.706V6.35294H11.2942V4.94118H9.88245V3.52941H11.2942V2.11765H12.706V3.52941H14.1177V4.94118ZM17.6472 5.64706H22.5883V8.47059H17.6472V5.64706ZM1.41187 5.64706H6.35304V8.47059H1.41187V5.64706ZM14.8236 12.9247V14.1176H19.0589V12.9247C17.6621 12.6344 16.2205 12.6344 14.8236 12.9247Z"
                    fill="rgb(var(--locumate-primary-color))" />
                  <path
                    d="M1.41176 9.88232V22.5882H0V24H24V22.5882H22.5882V9.88232H1.41176ZM10.5882 22.5882H9.17647V14.1176H4.94118V22.5882H3.52941V12.7059H10.5882V22.5882ZM20.4706 17.8244C18.3189 18.5161 15.5436 18.5089 13.4118 17.8245V11.8142C15.7813 11.1282 18.1016 11.1283 20.4706 11.8142V17.8244Z"
                    fill="rgb(var(--locumate-primary-color))" />
                  <path
                    d="M14.8235 16.7224C16.2203 17.0134 17.662 17.0134 19.0588 16.7225V15.5295H14.8235V16.7224ZM0 8.4707H1.41176V9.88247H0V8.4707ZM22.5882 8.4707H24V9.88247H22.5882V8.4707Z"
                    fill="rgb(var(--locumate-primary-color))" />
                </g>
                <defs>
                  <clipPath id="clip0_2459_4910">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{ exp?.title }}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  <!-- Master of Pharmacy -->
                </p>
                <p class="enhance-item-dates">
                  {{ exp.dateStart?.split('-')[0] }} - {{ exp.dateEnd?.split('-')[0] }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Skills
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openSkillsDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <div class="skill-list-pills">
            <el-tag v-for="(skill, index) in userData.skills" :key="index" class="inverted pill">
              {{ skill.name }}
            </el-tag>
          </div>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Education
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openEducationDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <div class="enhance-item border-box" v-for="(edu, index) in educations"
            :key="index">
            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.8942 7.06186H8.10581L12 5.06091L15.8942 7.06186ZM15.8942 11.4626H22.3694V21.2156H15.8939L15.8942 11.4626ZM17.8482 14.8203H20.4156V13.4503H17.848L17.8482 14.8203ZM20.4156 17.4641H17.848V18.8341H20.4154L20.4156 17.4641ZM8.10628 21.2154H1.63059V11.4626H8.10604L8.10628 21.2154ZM6.15224 17.4641H3.58457V18.8341H6.15201L6.15224 17.4641ZM3.58481 14.8203H6.15224V13.4503H3.58457L3.58481 14.8203ZM15.8942 10.8063H22.3694V9.19936C22.3694 9.15851 22.3531 9.11935 22.3242 9.09046C22.2953 9.06158 22.2562 9.04533 22.2153 9.04528H15.8939L15.8942 10.8063ZM10.8292 18.9917V21.2156H13.1708V18.9917C13.1708 18.6812 13.0475 18.3834 12.8279 18.1638C12.6083 17.9442 12.3105 17.8208 12 17.8208C11.6895 17.8208 11.3917 17.9442 11.1721 18.1638C10.9525 18.3834 10.8292 18.6812 10.8292 18.9917ZM15.2377 7.71825H8.76229V10.8063H15.2377V7.71825ZM8.10604 9.04528H1.78467C1.74382 9.04533 1.70466 9.06158 1.67577 9.09046C1.64689 9.11935 1.63064 9.15851 1.63059 9.19936V10.8063H8.10604V9.04528ZM22.7465 21.8719H1.25353C1.12367 21.8719 0.999139 21.9235 0.907319 22.0153C0.8155 22.1071 0.763916 22.2316 0.763916 22.3615C0.763916 22.4913 0.8155 22.6159 0.907319 22.7077C0.999139 22.7995 1.12367 22.8511 1.25353 22.8511H22.7465C22.8763 22.8511 23.0009 22.7995 23.0927 22.7077C23.1845 22.6159 23.2361 22.4913 23.2361 22.3615C23.2361 22.2316 23.1845 22.1071 23.0927 22.0153C23.0009 21.9235 22.8763 21.8719 22.7465 21.8719ZM13.8271 21.2156V18.9917C13.8271 18.5071 13.6346 18.0424 13.2919 17.6997C12.9493 17.3571 12.4846 17.1646 12 17.1646C11.5154 17.1646 11.0507 17.3571 10.708 17.6997C10.3654 18.0424 10.1729 18.5071 10.1729 18.9917V21.2156H8.76229V11.4626H15.2377V21.2156H13.8271ZM13.2837 13.4503H10.7163V14.8203H13.2837V13.4503ZM12.3281 4.4917V2.88389C12.5224 2.83517 12.722 2.81032 12.9223 2.80988C13.2809 2.80924 13.6345 2.89434 13.9536 3.05808C14.1582 3.16004 14.3814 3.21937 14.6096 3.23247C14.8378 3.24556 15.0663 3.21215 15.2812 3.13425V1.82789C14.7363 1.96999 14.1581 1.90803 13.6556 1.65366C13.451 1.55178 13.2279 1.49251 12.9997 1.47944C12.7715 1.46638 12.543 1.49978 12.3281 1.57763V1.47656C12.3281 1.38954 12.2935 1.30608 12.232 1.24454C12.1705 1.18301 12.087 1.14844 12 1.14844C11.913 1.14844 11.8295 1.18301 11.768 1.24454C11.7064 1.30608 11.6719 1.38954 11.6719 1.47656V4.4917L12 4.32295L12.3281 4.4917Z"
                  fill="#1746BB" />
              </svg>
            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{ edu.school }}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  {{ edu.title }}
                </p>
                <p class="enhance-item-dates">
                  {{ edu.dateStart?.split('-')[0] }} - {{ edu.dateEnd?.split('-')[0] }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Certifications
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openCertificateDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <div class="enhance-item border-box" v-for="(cer, index) in certifications"
            :key="index">
            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.8942 7.06186H8.10581L12 5.06091L15.8942 7.06186ZM15.8942 11.4626H22.3694V21.2156H15.8939L15.8942 11.4626ZM17.8482 14.8203H20.4156V13.4503H17.848L17.8482 14.8203ZM20.4156 17.4641H17.848V18.8341H20.4154L20.4156 17.4641ZM8.10628 21.2154H1.63059V11.4626H8.10604L8.10628 21.2154ZM6.15224 17.4641H3.58457V18.8341H6.15201L6.15224 17.4641ZM3.58481 14.8203H6.15224V13.4503H3.58457L3.58481 14.8203ZM15.8942 10.8063H22.3694V9.19936C22.3694 9.15851 22.3531 9.11935 22.3242 9.09046C22.2953 9.06158 22.2562 9.04533 22.2153 9.04528H15.8939L15.8942 10.8063ZM10.8292 18.9917V21.2156H13.1708V18.9917C13.1708 18.6812 13.0475 18.3834 12.8279 18.1638C12.6083 17.9442 12.3105 17.8208 12 17.8208C11.6895 17.8208 11.3917 17.9442 11.1721 18.1638C10.9525 18.3834 10.8292 18.6812 10.8292 18.9917ZM15.2377 7.71825H8.76229V10.8063H15.2377V7.71825ZM8.10604 9.04528H1.78467C1.74382 9.04533 1.70466 9.06158 1.67577 9.09046C1.64689 9.11935 1.63064 9.15851 1.63059 9.19936V10.8063H8.10604V9.04528ZM22.7465 21.8719H1.25353C1.12367 21.8719 0.999139 21.9235 0.907319 22.0153C0.8155 22.1071 0.763916 22.2316 0.763916 22.3615C0.763916 22.4913 0.8155 22.6159 0.907319 22.7077C0.999139 22.7995 1.12367 22.8511 1.25353 22.8511H22.7465C22.8763 22.8511 23.0009 22.7995 23.0927 22.7077C23.1845 22.6159 23.2361 22.4913 23.2361 22.3615C23.2361 22.2316 23.1845 22.1071 23.0927 22.0153C23.0009 21.9235 22.8763 21.8719 22.7465 21.8719ZM13.8271 21.2156V18.9917C13.8271 18.5071 13.6346 18.0424 13.2919 17.6997C12.9493 17.3571 12.4846 17.1646 12 17.1646C11.5154 17.1646 11.0507 17.3571 10.708 17.6997C10.3654 18.0424 10.1729 18.5071 10.1729 18.9917V21.2156H8.76229V11.4626H15.2377V21.2156H13.8271ZM13.2837 13.4503H10.7163V14.8203H13.2837V13.4503ZM12.3281 4.4917V2.88389C12.5224 2.83517 12.722 2.81032 12.9223 2.80988C13.2809 2.80924 13.6345 2.89434 13.9536 3.05808C14.1582 3.16004 14.3814 3.21937 14.6096 3.23247C14.8378 3.24556 15.0663 3.21215 15.2812 3.13425V1.82789C14.7363 1.96999 14.1581 1.90803 13.6556 1.65366C13.451 1.55178 13.2279 1.49251 12.9997 1.47944C12.7715 1.46638 12.543 1.49978 12.3281 1.57763V1.47656C12.3281 1.38954 12.2935 1.30608 12.232 1.24454C12.1705 1.18301 12.087 1.14844 12 1.14844C11.913 1.14844 11.8295 1.18301 11.768 1.24454C11.7064 1.30608 11.6719 1.38954 11.6719 1.47656V4.4917L12 4.32295L12.3281 4.4917Z"
                  fill="#1746BB" />
              </svg>
            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{ cer.name }}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  <!-- Master of Pharmacy -->
                </p>
                <p class="enhance-item-dates">
                  <!-- 2016 - 2018 -->
                </p>
              </div>
            </div>
          </div>
        </div>
       
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Resume
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openCvDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <div v-if="existingCvs.length > 0">
            <div class="pdf-preview border-box" v-for="(cvs, index) in existingCvs" :key="index"  @click="openResumeDialog(index)">
              <div class="pdf-preview__icon" @click="openResumeDialog(index)">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect width="32" height="32" fill="url(#pattern0_2575_7976)" />
                                    <defs>
                                        <pattern id="pattern0_2575_7976" patternContentUnits="objectBoundingBox"
                                            width="1" height="1">
                                            <use xlink:href="#image0_2575_7976" transform="scale(0.00195312)" />
                                        </pattern>
                                        <image id="image0_2575_7976" width="512" height="512"
                                            xlink:href="data:image/png;base64,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" />
                                    </defs>
                                </svg>
              </div>
              <div class="pdf-preview-detail" @click="openResumeDialog(index)">
                <p class="pdf-preview-title">{{ cvs.userFriendlyName }}</p>
                <p class="pdf-preview-info">File size {{ cvs.size }}MB | {{ cvs.createdAt }}</p>
              </div>
              <div data-testid="directions-120" class="edit-icon ml-auto p-2" @click="openResumeDialog(index)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;">
                <path d="M12.9834 10.0001C12.9834 11.6501 11.6501 12.9834 10.0001 12.9834C8.35006 12.9834 7.01672 11.6501 7.01672 10.0001C7.01672 8.35006 8.35006 7.01672 10.0001 7.01672C11.6501 7.01672 12.9834 8.35006 12.9834 10.0001Z" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99999 16.8916C12.9417 16.8916 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00831 17.5917 7.83331C15.6833 4.83331 12.9417 3.09998 9.99999 3.09998C7.05833 3.09998 4.31666 4.83331 2.40833 7.83331C1.65833 9.00831 1.65833 10.9833 2.40833 12.1583C4.31666 15.1583 7.05833 16.8916 9.99999 16.8916Z" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </div>
          </div>
          </div>
   
        </div>
        
      </div>
    </div>
    <!-- Job Seeker settings page item -->
  </div>
  <!-- About me dialog -->
  <el-drawer title="About Me" v-model="dialogVisible" :append-to-body="true" :direction="'btt'"
    :destroy-on-close="true">
    <el-form :model="editAboutForm" ref="editForm">
      <el-form-item>
        <el-input v-model="editAboutForm.about_me" type="textarea" rows="4"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="d-flex gap-1 my-3">
      <el-button type="primary" class="mt-0" @click="saveAboutMe">Save</el-button>
      <el-button class="secondary mt-0" @click="closeDialog">Cancel</el-button>
    </div>
  </el-drawer>

  <!-- Edit cv dialog -->
  <el-drawer title="Update your CV" custom-class="bottom_drop_up pdf-update" popper-class="bottom-drawer" v-model="dialogResumeVisible"
            :append-to-body="true" :direction="'btt'" :destroy-on-close="true">
          
            <div class="cv-upload">
                <div class="cv-upload-title">Browse Your Files</div>

                <div class="cv-upload-info">Support Format : PDF | Maximum 10 MB </div>
                <el-upload class="upload-demo hover-fix" :headers="headers" :action="CV_UPLOAD_BASE_URL"
                    :on-success="handleSuccess" :before-upload="beforeUpload" drag>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.6665V6.6665L11.6667 4.99984" stroke="white" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0002 6.66667L8.3335 5" stroke="white" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M5.83333 10C2.5 10 2.5 11.4917 2.5 13.3333V14.1667C2.5 16.4667 2.5 18.3333 6.66667 18.3333H13.3333C16.6667 18.3333 17.5 16.4667 17.5 14.1667V13.3333C17.5 11.4917 17.5 10 14.1667 10C13.3333 10 13.1 10.175 12.6667 10.5L11.8167 11.4C10.8333 12.45 9.16667 12.45 8.175 11.4L7.33333 10.5C6.9 10.175 6.66667 10 5.83333 10Z"
                            stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M4.1665 10V6.6667C4.1665 4.9917 4.1665 3.60837 6.6665 3.3667" stroke="white"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.8335 10V6.6667C15.8335 4.9917 15.8335 3.60837 13.3335 3.3667" stroke="white"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="el-upload__text">
                        Upload File
                    </div>
                </el-upload>
            </div>

            <div class="file-lists">
                <div v-for="(cv, index) in existingCvs" :key="cv.id">
                    <div class="el-upload-list">
                        <div class="el-upload-list__item">
                            <div class="thumbnail_img el-upload-list--picture-card">
                              <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect width="32" height="32" fill="url(#pattern0_2575_7976)" />
                                    <defs>
                                        <pattern id="pattern0_2575_7976" patternContentUnits="objectBoundingBox"
                                            width="1" height="1">
                                            <use xlink:href="#image0_2575_7976" transform="scale(0.00195312)" />
                                        </pattern>
                                        <image id="image0_2575_7976" width="512" height="512"
                                            xlink:href="data:image/png;base64,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" />
                                    </defs>
                                </svg>
                            </div>
                            <div class="upload-text">
                                <div class="upload-text-title flex-1 mr-2">

                                    <span v-if="!renamingCvIds.includes(cv.id)" @click.prevent="openCvModal(cv)">{{ cv.userFriendlyName }}</span>
                <el-input
                  v-if="renamingCvIds.includes(cv.id)"
                  v-model="renameValues[cv.id]"
                  size="small"
                  placeholder="Enter new name"
                  maxlength="250"
                  show-word-limit
                  @click.stop
                />
              <p v-if="renamingCvIds.includes(cv.id) && !renameValues[cv.id]" class="error-message">
      Name is required.
    </p>
              <div class="action-icons">
                <el-button
                  v-if="!renamingCvIds.includes(cv.id)"
                  @click="enableRename(cv.id, cv.userFriendlyName)"
                  size="small"
                  type="text"
                  class="mt-0 text-only"
                >
                  Rename
                </el-button>
                <el-button
                  v-if="renamingCvIds.includes(cv.id)"
                  @click="confirmRename(index)"
                  size="small"
                  type="primary"
                  class="mt-2"
                   :disabled="!renameValues[cv.id]"
                >
                  Confirm
                </el-button>
                <el-button
                  v-if="renamingCvIds.includes(cv.id)"
                  @click="cancelRename(cv.id)"
                  size="small"
                  type="danger"
                  class="danger mt-2"
                >
                  Cancel
                </el-button>
                </div>
                                </div>

                                <div class="remove-icon m-0" @click="removeResume(index)">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2 2L14 14" stroke="#FF0000" stroke-width="2"/>
                                  <path d="M2 14L14 2" stroke="#FF0000" stroke-width="2"/>
                                </svg>
                                
                              </div>
                                <el-dialog title="CV Preview" v-model="modalVisibleCv" width="50%"
                                    :close-on-click-modal="true" @close="closeCvModal">
                                    <vue-pdf-embed :source="selectedCv.url" />

                                </el-dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <el-button class="submit" type="blue" data-testid="directions-91" @click="handleConfirm">
                Close
            </el-button>
        </el-drawer>

  <!-- experience dialog  -->
  <ExperiencesDrawer :experienceDialogVisible="experienceDialogVisible" @closeExperienceDrawer="closeExperienceDialog"/>
  <!-- Edit Skills dialog -->
  <el-drawer title="Skills" v-model="skillsDialogVisible" :append-to-body="true" :direction="'btt'"
    :destroy-on-close="true">
    <div  class="edit-skills-drawer">
      <el-select class="skill-search-selector custom-select" popper-class="normal-select" v-model="selectedSkills"
        multiple filterable remote :loading="loading" :remote-method="remoteMethod" placeholder="Search and select skills">
        <el-option v-for="item in skillsOptions" :key="item.value" :label="item.label" :value="item"></el-option>
      </el-select>
      <div class="edit-skills-container">
        <div class="tags-wrapper">
          <el-tag v-for="(skill, index) in editSkillsForm.skills" :key="index" closable @close="removeSkill(skill)"
            class="edit-skill-tag inverted pill">
            {{ skill.name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div slot="footer" class="d-flex gap-1 my-3">
      <el-button type="primary" class="mt-0" @click="saveSkills" v-if="showSaveSkillsBtn">Save</el-button>
      <el-button class="secondary mt-0" @click="closeSkillsDialog">Cancel</el-button>
    </div>
  </el-drawer>
  <!-- education dialog  -->
  <EducationsDrawer :educationDialogVisible="educationDialogVisible" @closeEducationDrawer="closeEducationDialog"/>
  <!-- certificate dialog  -->
  <CertificationsDrawer :certificationDialogVisible="certificationDialogVisible" @closeCertificationDrawer="closeCertificationDialog"/>
<!-- passwordchange -->


  <!-- resume dialog -->
  <!-- <el-dialog v-model="resumeDialogVisible" title="Resume" @close="closeCertificateDialog"> -->
  <el-drawer v-model="resumeDialogVisible" :append-to-body="true" title="Resume" :direction="'btt'"
    :destroy-on-close="true">
    <vue-pdf-embed v-if="userData.locumCvs && userData.locumCvs.length > 0 && selectedCvIndex !== null"
      :source="userData.locumCvs[selectedCvIndex].url"></vue-pdf-embed>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="closeCertificateDialog">Cancel</el-button>
        <el-button type="primary" @click="saveCertificates">Save</el-button> -->
    </div>
  </el-drawer>
  <el-drawer class="job-seeker-profile" custom-class="job-seeker-profile" direction="ttb" v-model="jobSeekerDrawer"
        :show-close="true" append-to-body="true">
        <div class="job-seeker-profile-wrapper">
          <div class="profile-top">
            <div class="image" v-if="user.image">
              <img :src="user.image" alt="profile" />
            </div>
            <div class="image" v-else>
             <el-avatar  :size="'large'" :shape="'square'" icon="el-icon-user-solid"></el-avatar>
           </div>
            <div class="details">
              <h3>{{ user.name ? user.name : 'N/A' }}</h3>

              <!-- <p>{{ $filters.userRoleConversion(user) }}</p> -->
               <p>{{ user.platformRole }}</p>
            </div>
          </div>
          <div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M16.0083 13.1167L13.0583 16.0667C12.9416 16.1834 12.8333 16.4 12.8083 16.5584L12.6499 17.6833C12.5916 18.0917 12.875 18.375 13.2833 18.3167L14.4083 18.1583C14.5666 18.1333 14.7916 18.025 14.9 17.9084L17.8499 14.9584C18.3583 14.45 18.5999 13.8583 17.8499 13.1083C17.1083 12.3667 16.5166 12.6083 16.0083 13.1167Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5833 13.5416C15.8333 14.4416 16.5332 15.1416 17.4332 15.3916"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content" @click="links.changeJobSeekerAdditional">
                <div class="setting-item__title">
                  Account
                </div>
                <div class="setting-item__description">
                  Update your account settings
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75836 12.2501L9.00836 13.5001L12.3417 10.1667" stroke="rgb(var(--locumate-primary-color))"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8.33335 5.00008H11.6667C13.3334 5.00008 13.3334 4.16675 13.3334 3.33341C13.3334 1.66675 12.5 1.66675 11.6667 1.66675H8.33335C7.50002 1.66675 6.66669 1.66675 6.66669 3.33341C6.66669 5.00008 7.50002 5.00008 8.33335 5.00008Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>


              </div>
              <div class="setting-item__content" @click="links.goToPreviousApplications">
                <div class="setting-item__title">
                  Previous Jobs
                </div>
                <div class="setting-item__description">
                  View your previous jobs
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3334 8.33341V12.5001C18.3334 16.6667 16.6667 18.3334 12.5 18.3334H7.50002C3.33335 18.3334 1.66669 16.6667 1.66669 12.5001V7.50008C1.66669 3.33341 3.33335 1.66675 7.50002 1.66675H11.6667"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3334 8.33341H15C12.5 8.33341 11.6667 7.50008 11.6667 5.00008V1.66675L18.3334 8.33341Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.83331 10.8333H10.8333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.83331 14.1667H9.16665" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="setting-item__content" @click="links.goToTermsAndConditions">
                <div class="setting-item__title">
                  Terms & Conditions
                </div>
                <div class="setting-item__description">
                  View Terms & Conditions
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3084 15.2751C18.3084 15.5751 18.2417 15.8834 18.1001 16.1834C17.9584 16.4834 17.7751 16.7667 17.5334 17.0334C17.1251 17.4834 16.6751 17.8084 16.1667 18.0167C15.6667 18.2251 15.1251 18.3334 14.5417 18.3334C13.6917 18.3334 12.7834 18.1334 11.8251 17.7251C10.8667 17.3167 9.90842 16.7667 8.95842 16.0751C8.00008 15.3751 7.09175 14.6001 6.22508 13.7417C5.36675 12.8751 4.59175 11.9667 3.90008 11.0167C3.21675 10.0667 2.66675 9.11675 2.26675 8.17508C1.86675 7.22508 1.66675 6.31675 1.66675 5.45008C1.66675 4.88341 1.76675 4.34175 1.96675 3.84175C2.16675 3.33341 2.48341 2.86675 2.92508 2.45008C3.45841 1.92508 4.04175 1.66675 4.65841 1.66675C4.89175 1.66675 5.12508 1.71675 5.33341 1.81675C5.55008 1.91675 5.74175 2.06675 5.89175 2.28341L7.82508 5.00841C7.97508 5.21675 8.08341 5.40841 8.15841 5.59175C8.23341 5.76675 8.27508 5.94175 8.27508 6.10008C8.27508 6.30008 8.21675 6.50008 8.10008 6.69175C7.99175 6.88341 7.83341 7.08341 7.63341 7.28341L7.00008 7.94175C6.90841 8.03341 6.86675 8.14175 6.86675 8.27508C6.86675 8.34175 6.87508 8.40008 6.89175 8.46675C6.91675 8.53341 6.94175 8.58341 6.95842 8.63341C7.10842 8.90841 7.36675 9.26675 7.73341 9.70008C8.10841 10.1334 8.50841 10.5751 8.94175 11.0167C9.39175 11.4584 9.82508 11.8667 10.2667 12.2417C10.7001 12.6084 11.0584 12.8584 11.3417 13.0084C11.3834 13.0251 11.4334 13.0501 11.4917 13.0751C11.5584 13.1001 11.6251 13.1084 11.7001 13.1084C11.8417 13.1084 11.9501 13.0584 12.0417 12.9667L12.6751 12.3417C12.8834 12.1334 13.0834 11.9751 13.2751 11.8751C13.4667 11.7584 13.6584 11.7001 13.8667 11.7001C14.0251 11.7001 14.1917 11.7334 14.3751 11.8084C14.5584 11.8834 14.7501 11.9917 14.9584 12.1334L17.7167 14.0917C17.9334 14.2417 18.0834 14.4167 18.1751 14.6251C18.2584 14.8334 18.3084 15.0417 18.3084 15.2751Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
                  <path
                    d="M15.4167 7.50016C15.4167 7.00016 15.025 6.2335 14.4417 5.6085C13.9083 5.0335 13.2 4.5835 12.5 4.5835"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3333 7.50008C18.3333 4.27508 15.725 1.66675 12.5 1.66675"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content">
                <a
            :href="supportLink"
            target="_blank"
            data-testid="support-btn"
          >
                <div class="setting-item__title">
                  Support Team
                </div>
                <div class="setting-item__description">
                  Get connected with the Support Team
                </div>
                </a>
              </div>
            </div>
          </div>
          <el-button class="text-only logout-btn" @click="links.logout">
            LOGOUT
          </el-button>
        </div>
      </el-drawer>
</template>

<script>
import { ref, onMounted, inject, reactive, watch, computed, onBeforeMount } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonTitle } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter } from "vue-router";

import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

import VuePdfEmbed from 'vue-pdf-embed';

import EditIcon from "@/components/Icons/EditIcon.vue";
import SmsTrackingIcon from "@/components/Icons/SmsTrackingIcon.vue";
import EditOutlineIcon from "@/components/Icons/EditOutlineIcon.vue";
import MobileIcon from "@/components/Icons/MobileIcon.vue";
import TeacherIcon from "@/components/Icons/TeacherIcon.vue";
import ProfileTickIcon from "@/components/Icons/ProfileTickIcon.vue";
import ExperiencesDrawer from "./Components/ExperiencesDrawer.vue";
import CertificationsDrawer from "./Components/CertificationsDrawer.vue";
import EducationsDrawer from "./Components/EducationsDrawer.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  components: {
    IonToolbar,
    IonTitle,
    VuePdfEmbed,
    EditIcon,
    SmsTrackingIcon,
    EditOutlineIcon,
    MobileIcon,
    TeacherIcon,
    ProfileTickIcon,
    ExperiencesDrawer,
    CertificationsDrawer,
    EducationsDrawer,
  },
  directives: {},
  setup() {
    let supportLink = ref(null);
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const mainMenuShow = inject("mainMenuShow");

    const userData = ref($store.getters.GET_USER_DATA ? $store.getters.GET_USER_DATA : {});
    console.log("🚀 ~ setup ~ userData:", userData)
    const dialogVisible = ref(false);
    const skillsDialogVisible = ref(false);
    const experienceDialogVisible = ref(false);
    const educationDialogVisible = ref(false);
    const certificationDialogVisible = ref(false);
    const resumeDialogVisible = ref(false);
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();
    const dialogResumeVisible = ref(false);
    const existingCvs = ref([]);
    const modalVisibleCv = ref(false);
    const selectedCv = ref(null);
    const token = $store.getters.GET_TOKEN;
    const selectedCvIndex = ref(null);
    const jobSeekerDrawer = ref(false);
    const originalSkills = ref([]);
    const state = reactive({
      isTruncated: true
    });
// Refs for tracking renaming state
const renamingCvIds = ref([])
const renameValues = ref({})
const user = $store.getters.GET_USER_DATA;

const certifications = computed(() => {
  return userData.value.settings?.hrFlowData?.certifications || userData.value.locumAsJobSeekerSetting?.hrFlowData?.certifications || [];
});

const experiences = computed(() => {
  return userData.value.settings?.hrFlowData?.experiences || userData.value.locumAsJobSeekerSetting?.hrFlowData?.experiences || [];
});

const educations = computed(() => {
  return userData.value.settings?.hrFlowData?.educations || userData.value.locumAsJobSeekerSetting?.hrFlowData?.educations || [];
});

const regex = /http:\/\/|https:\/\//gm;
supportLink.value = user.supportSite.replace(regex, "");
supportLink = `https://${supportLink.value}`;


const rules = computed(() => ({
      renameValues: Object.keys(renameValues).reduce((acc, id) => {
        acc[id] = { required };
        return acc;
      }, {}),
    }));

    const v$ = useVuelidate(rules, { renameValues });


const links = {
changeJobSeekerAdditional: () => {
  $router.push({
    name: "additional_profile_job_seeker",
  });
},
changeBasicProfileJobSeeker: () => {
  if (user.role === "locum") {
      $router.push({
        name: "profile_edit",
      });
    } else {
      $router.push({
        name: "basic_profile_job_seeker",
      });
    }
 
},
changePhoto: () => {
  $router.push({
    name: "profile_photo_job_seeker",
  });
},
notifications: () => {
  $router.push({
    name: "profile_notifications",
  });
},
goToAbout: () => {
  const link = document.getElementById("goToAboutPage");
  link.click();
},

goToTermsAndConditions: () => {
  $router.push({
    name: "terms_and_conditions",
  });
},
goToPreviousApplications: () => {
  $router.push({
    name: "job_seeker_previous_applications",
  });
},
goToPrivacyPolicy: () => {
  $router.push({
    name: "privacy_policy",
  });
},

logout: () => {
  (async () => {
    try {
      await ElMessageBox.confirm(
        ``,
        "Are you sure you want to log out?",
        {
          distinguishCancelAndClose: true,
          showConfirmButton: true,
          confirmButtonText: "Logout",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--green",
          cancelButtonClass: "el-button--grey",
          showClose: true,
        }
      );
    } catch {
      return;
    }
    try {
      await $store.dispatch("AUTH_LOGOUT");
    } catch (error) {
      console.log(error);
    }
  })();
},
};
    const backPage = $store.getters.getLastPage;
    console.log("🚀 ~ setup ~ backPage:", backPage)

    const displayedText = computed(() => {
      const aboutMeText = userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || '';
      if (state.isTruncated && aboutMeText && aboutMeText.split(' ').length > 50) {
        return aboutMeText.split(' ').slice(0, 50).join(' ') + '...';
      } else {
        return aboutMeText;
      }
    });

    const isDisplayButtonVisible = computed(() => {
      const aboutMeText = userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || '';
      return aboutMeText.split(' ').length > 50;
    });

    const toggleView = () => {
      state.isTruncated = !state.isTruncated;
    };

    const openDialog = () => {
      editAboutForm.about_me = userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || '';
      dialogVisible.value = true;
    };

    const openExperienceDialog = () => {
      experienceDialogVisible.value = true;
    };
    const openCertificateDialog = () => {
      // editCertificateForm.certifications = userData.value.settings.hrFlowData?.certifications ? userData.value.settings.hrFlowData?.certifications : [];
      certificationDialogVisible.value = true;
    };

    const openEducationDialog = () => {
      educationDialogVisible.value = true;
    };

    const openResumeDialog = (index) => {
      selectedCvIndex.value = index;
      resumeDialogVisible.value = true;
    };


    // Form model for editing About Me
    const editAboutForm = reactive({
      about_me: userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || ''
    });  

    const editSkillsForm = reactive({
      skills: userData.value.skills ? userData.value.skills : [],
    });

    onMounted(() => {
      setPageClassGlobal("global_job_seeker_profile_page");
      mainMenuShow(true);
    });

    const CV_UPLOAD_BASE_URL = process.env.VUE_APP_BASEURL + "/job-seeker/file/ajaxCvUpload";
        console.log(CV_UPLOAD_BASE_URL);
        const headers = {
            'Authorization': "Bearer " + token
        };


    const selectedSkills = ref([]);
    const skillsOptions = ref([]);
    const loading = ref(false);

    const remoteMethod = debounce(async (query) => {
      loading.value = true;
      try {
        const response = await $store.dispatch("GET_ALL_SKILLS", {
          'search': query
        });
        skillsOptions.value = response.data
          .map(skill => ({ label: skill.name, value: skill.id }));
      } catch (error) {
        console.error('Error fetching skills:', error);
      } finally {
        loading.value = false;
      }
    }, 300);

    function debounce(func, wait) {
      let timeout;
      return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }


    watch(selectedSkills, (newSelectedSkills, oldSelectedSkills) => {
      const addedSkills = newSelectedSkills.filter(skill => !oldSelectedSkills.some(oldSkill => oldSkill.value === skill.value));
      const removedSkills = oldSelectedSkills.filter(skill => !newSelectedSkills.some(newSkill => newSkill.value === skill.value));

      // Transform selected skills to desired format
      const transformedSkills = newSelectedSkills.map(skill => ({
        name: skill.label,
        id: skill.value
      }));

      // Add new selected skills to editSkillsForm.skills
      editSkillsForm.skills.push(...transformedSkills.filter(skill => addedSkills.some(addedSkill => addedSkill.value === skill.id)));

      // Remove deselected skills from editSkillsForm.skills
      removedSkills.forEach(removedSkill => {
        const index = editSkillsForm.skills.findIndex(skill => skill.id === removedSkill.value);
        if (index !== -1) {
          editSkillsForm.skills.splice(index, 1);
        }
      });
    });

    const closeDialog = () => {
      dialogVisible.value = false;
    };
    const closeExperienceDialog = () => {
      experienceDialogVisible.value = false;
    };
    const closeEducationDialog = () => {
      educationDialogVisible.value = false;
    };

    const closeCertificationDialog = () => {
      certificationDialogVisible.value = false;
    };

    // Method to save edited About Me
    const saveAboutMe = async () => {
      // Save data using Vuex action or any other method
      try {
        await ElMessageBox.confirm(
          `Are you sure you want to update about me?`,
          "Update",
          {
            confirmButtonText: "Update",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--primary",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );

        await (async () => {
          try {
            const response = await $store.dispatch("UPDATE_JOB_SEEKER_ABOUT", { params: editAboutForm });
            console.log("🚀 ~ await ~ response:", response)
            $store.dispatch("SET_CURRENT_USER_DATA", {
              with:
                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
            });
            if (response.success) {
              ElMessage({
                type: "success",
                message: response.message,
              });

            } else {
              ElMessage({
                type: "info",
                message: response.message,
              });
            }
          } catch (error) {
            ElMessage({
              type: "error",
              message: error.message,
            });
          }
        })();
      } catch (error) {
        console.log(error);
      }
      // Close dialog after saving

      closeDialog();
    };

    // Method to open skills dialog
    const openSkillsDialog = () => {
      originalSkills.value = JSON.parse(JSON.stringify(userData.value.skills));
      editSkillsForm.skills = JSON.parse(JSON.stringify(originalSkills.value));
      skillsDialogVisible.value = true;
    };

    // Method to close skills dialog
    const closeSkillsDialog = () => {
      editSkillsForm.skills = JSON.parse(JSON.stringify(originalSkills.value));
      selectedSkills.value = [];
      skillsDialogVisible.value = false;
    };

    const showSaveSkillsBtn = computed(() => {
      //return (JSON.stringify(editSkillsForm.skills) !== JSON.stringify(originalSkills.value)) || (selectedSkills && selectedSkills.length > 0);
      return editSkillsForm.skills.length > 0;
    });

    // Method to remove a skill from editSkillsForm
    const removeSkill = (skill) => {
      const skillIndex = editSkillsForm.skills.findIndex(s => s.id === skill.id);
      if (skillIndex !== -1) {
        editSkillsForm.skills.splice(skillIndex, 1);
      }

      const selectedSkillIndex = selectedSkills.value.findIndex(s => s.value === skill.id);
      if (selectedSkillIndex !== -1) {
        selectedSkills.value.splice(selectedSkillIndex, 1);
      }
    };

    // Method to save edited skills
    const saveSkills = async () => {

      try {
        await ElMessageBox.confirm(
          `Are you sure you want to update skills?`,
          "Update Skills",
          {
            confirmButtonText: "Update",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--primary",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );

        await (async () => {
          try {
            const response = await $store.dispatch("UPDATE_JOB_SEEKER_SKILLS", { params: editSkillsForm });
            console.log("🚀 ~ await ~ response:", response)
            $store.dispatch("SET_CURRENT_USER_DATA", {
              with:
                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
            });
            if (response.status) {
              ElMessage({
                type: "success",
                message: response.message,
              });
              selectedSkills.value = [];
              skillsDialogVisible.value = false;
            } else {
              ElMessage({
                type: "info",
                message: response.message,
              });
            }
          } catch (error) {
            ElMessage({
              type: "error",
              message: error.message,
            });
          }          
        })();
      } catch (error) {
        console.log(error);
      }

    };


    onBeforeMount(async () => {
      await $store.dispatch("SET_CURRENT_USER_DATA", {
        with: "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
      });
      getExistingCvs();
    });

    const openCvDialog = () => {
            dialogResumeVisible.value = true;
        };

    const handleClose = () => {
        dialogResumeVisible.value = false;
    };

    const handleConfirm = () => {
        // Handle confirmation logic
        // console.log('Selected option:', selectedOption.value);
        dialogResumeVisible.value = false;
    };
  
    const handleSuccess = (response, file, fileList) => {
            console.log("🚀 ~ handleSuccess ~ fileList:", fileList)
            console.log("🚀 ~ handleSuccess ~ file:", file)
            console.log("🚀 ~ handleSuccess ~ response:", response)
            // Handle successful upload
            ElMessage.success('Upload success');
            getExistingCvs();

        };

        const getExistingCvs = () => {
            // Dispatch second action
            (async () => {
                const existingCvResponse = await $store.dispatch("GET_JOB_SEEKER_EXISTING_CV");
                existingCvs.value = existingCvResponse.data;

                //select the Last CV    
                if (existingCvs.value.length > 0) {
                    selectedCv.value = existingCvs.value[existingCvs.value.length - 1];

                    // console.log('selectedCv:', selectedCv.value, existingCvs.value.length);
                }
            })();
        }

        const openCvModal = (cv) => {
            // Set the file URL to be displayed in the modal
            selectedCv.value = cv;
            // Show the modal
            modalVisibleCv.value = true;
        };

        const closeCvModal = () => {
            modalVisibleCv.value = false;
        };

        const beforeUpload = (file) => {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                // If the file is not a PDF, display an error message
                // You may need to import 'ElMessage' from 'element-plus' or 'element-ui' depending on your setup
                ElMessage.error('Please upload PDF files only.');
            }
            return isPDF;
        };

        const removeResume = async (index) => {
          console.log("🚀 ~ removeResume ~ index:", index)
          const cvId = existingCvs.value[index].id;
          console.log("🚀 ~ removeResume ~ cvId:", cvId)

          try {
            // Confirmation dialog before removing
            await ElMessageBox.confirm('Are you sure you want to remove this CV?', 'Warning', {
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel',
              customClass: 'delete-prompt'
            });

            // API call to delete CV from the backend
            // await axios.delete(`/api/cvs/${cvId}`);
            await $store.dispatch("DELETE_JOB_SEEKER_FILE", cvId);
            // Remove the CV from the array after successful API call
            existingCvs.value.splice(index, 1);

            // Display success message
            ElMessage({
              type: 'success',
              message: 'CV removed successfully!',
            });
          } catch (error) {
            // Handle errors and show a failure message
            console.error('Error removing CV:', error);
            ElMessage({
              type: 'error',
              message: 'Failed to remove CV. Please try again.',
            });
          }
        };

        const enableRename = (id, currentName) => {
          renamingCvIds.value.push(id)
          renameValues.value[id] = currentName.replace('.pdf', '') // Remove the .pdf extension
        }

const confirmRename = async(index) => {
  const id = existingCvs.value[index].id
  const newName = renameValues.value[id]?.trim()
  if (newName) {
    try {
            // Confirmation dialog before removing
            await ElMessageBox.confirm('Are you sure you want to rename this CV?', 'Warning', {
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel',
              customClass: 'delete-prompt'
            });
            existingCvs.value[index].userFriendlyName = newName + '.pdf' // Append the .pdf extension
            renamingCvIds.value = renamingCvIds.value.filter((cvId) => cvId !== id)
            // API call to delete CV from the backend
            // await axios.delete(`/api/cvs/${cvId}`);
            await await $store.dispatch("RENAME_CV", {
              id: id,
              rename_text:existingCvs.value[index].userFriendlyName
            });
            // Remove the CV from the array after successful API call
            
            delete renameValues.value[id]
            mainMenuShow(true);
            // Display success message
            ElMessage({
              type: 'success',
              message: 'CV renamed successfully!',
            });
          } catch (error) {
            // Handle errors and show a failure message
            console.error('Error renaming CV:', error);
            // ElMessage({
            //   type: 'error',
            //   message: 'Failed to rename CV. Please try again.',
            // });
          }
  }

  
}

const cancelRename = (id) => {
  renamingCvIds.value = renamingCvIds.value.filter((cvId) => cvId !== id)
  delete renameValues.value[id]
}



    return {
      renamingCvIds,
      renameValues,
      enableRename,
      confirmRename,
      cancelRename,
      openCvDialog,
      handleClose,
      handleConfirm,
      dialogResumeVisible,
      handleSuccess,
      getExistingCvs,
      existingCvs,
      modalVisibleCv,
      selectedCv,
      openCvModal,
      closeCvModal,
      beforeUpload,CV_UPLOAD_BASE_URL,
      headers,
      selectedCvIndex,
      removeResume,
      userData,
      supportLink,
      links,
      dialogVisible,
      skillsDialogVisible,
      experienceDialogVisible,
      educationDialogVisible,
      resumeDialogVisible,
      state,
      selectedSkills,
      skillsOptions,
      loading,
      remoteMethod,
      closeDialog,
      closeExperienceDialog,
      closeEducationDialog,
      saveAboutMe,
      openSkillsDialog,
      closeSkillsDialog,
      removeSkill,
      saveSkills,
      displayedText,
      isDisplayButtonVisible,
      toggleView,
      openDialog,
      openExperienceDialog,
      openEducationDialog,
      openCertificateDialog,
      openResumeDialog,
      editAboutForm,
      editSkillsForm,
      isUS,
      isAustralia,
      closeCertificationDialog,
      certificationDialogVisible,
      jobSeekerDrawer,
      user,
      educations,
      certifications,
      experiences,
      v$,
      showSaveSkillsBtn,
    };
  },
};
</script>

<style scoped lang="scss">
.text_wrapper_shift {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;

  .main_text_shift {
    color: rgb(121, 121, 121);
    font-size: 1.1rem;
    font-weight: 500;
  }

  .additional_text_shift {
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;
    display: block;
  }
}
</style>
